// Loader.tsx
import React from "react";
import Logo from "../../assets/logo.svg";
import "./Loader.scss";

interface LoaderProps {
    loading: boolean;
    children: React.ReactNode;
    position?: "center" | "relative";
    /** Short status text under the spinner (replaces default "Loading" copy area). */
    tip?: string;
    /** When set, replaces the default logo + dots block (use for rich overlay UIs). */
    overlayContent?: React.ReactNode;
}

const Loader: React.FC<LoaderProps> = ({
    loading,
    children,
    position = "center",
    tip,
    overlayContent,
}) => {
    return (
        <div className={`awesome-loader-container ${position}`}>
            {loading && (
                <div className="awesome-loader-overlay">
                    <div className="awesome-loader-content">
                        {overlayContent != null ? (
                            <div className="loader-overlay-custom">
                                {overlayContent}
                            </div>
                        ) : (
                            <>
                                <div className="spin-container">
                                    <img
                                        src={Logo}
                                        alt="Logo"
                                        className="spin-logo"
                                    />
                                </div>
                                <div className="pulsing-dots">
                                    <p className="loader-text">
                                        {tip ?? "Loading"}
                                    </p>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            <div className={`main-content ${loading ? "blurred" : ""}`}>
                {children}
            </div>
        </div>
    );
};

export default Loader;
